export const sortListBy = ({ data, field, type }) => {
  switch (type) {
    case "date":
      data.sort((a, b) => {
        const parseDate = (date) => {
          const parts = date.split("/");

          // If MM/DD/YYYY format
          if (parts.length === 3) {
            const [month, day, year] = parts.map(Number);
            return { year, month, day };
          }
          // If MM/YYYY format (default day as 1)
          const [month, year] = parts.map(Number);
          return { year, month, day: 1 };
        };

        const dateA = parseDate(a?.[field]);
        const dateB = parseDate(b?.[field]);

        // Compare by year first, then by month, then by day
        if (dateA.year !== dateB.year) {
          return dateA.year - dateB.year;
        }
        if (dateA.month !== dateB.month) {
          return dateA.month - dateB.month;
        }
        return dateA.day - dateB.day;
      });
      break;
    default:
      throw new Error("Unsupported sort type");
  }
};
